import { Col, Row, Typography } from "antd";
import { useRouteError } from "react-router-dom";

const { Paragraph, Title } = Typography;

export default function Error({ status, errors }) {
  let error = useRouteError();
  // console.log(error);
  return (
    <Row
      align="middle"
      justify="center"
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#60A5FA",
      }}
    >
      <Col xs={{ span: 22, offset: 1 }} lg={{ span: 20, offset: 2 }}>
        <Title style={{ color: "white", fontSize: "60px" }}>
          {error?.status || status || "Oppsss..."}
        </Title>
        <Paragraph style={{ color: "white", fontSize: "24px" }}>
          {error?.statusText}
          {Array.isArray(errors) ? (
            errors.map((err) => <p className="mb-0">{err}</p>)
          ) : (
            <p>{errors}</p>
          )}
          {!error?.statusText && !errors ? "Something went wrong." : null}
        </Paragraph>
      </Col>
    </Row>
  );
}
